/**
 * Voxel physics engine — shared types.
 *
 * The engine collides against the voxel weight field directly (the same data the
 * SurfaceNets mesher consumes), never against meshes. It is three.js-free, allocation-free
 * per step, and deterministic: `stepPlayer(state, input, field, dt)` is a pure function of
 * plain data, so the client, tests, and a future server-side validator all replay ticks
 * identically.
 */
// ============== Queries ==============
/** Collidability mask bits for raycasts (by material type of weight-solid corners). */
export const RAY_SOLID = 1;
export const RAY_LIQUID = 2;
export const RAY_TRANSPARENT = 4;
//# sourceMappingURL=types.js.map